<div class="form-group text-center">
  <a (click)="onClick()">{{ getTitle() }}</a>
</div>